import { Component, OnInit } from '@angular/core';

import { OrderService } from '../../../POSServices/Setup/order.service';

import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-receipt-view',
  templateUrl: './order-receipt-view.component.html',
  styleUrls: ['./order-receipt-view.component.scss']
})
export class OrderReceiptViewComponent implements OnInit {
  merchantdata: UserPOSData ;
  UseLargeFond:boolean=false;
  OrderNotes:boolean=false;
  UserAlternativeInventoryName:boolean=false;
  GroupLineItems:boolean=false;
  ShowModifierName:boolean=false;
  GroupModifiers:boolean=false;
  ShowCustomerInfo:boolean=false;
  SmsReceipt:boolean=false;
  EmailReceipt:boolean=false;
receiptId;
PosSubscriptionId;
AddNoofBlankLineTopOfReceipt;
OrderNumberType;
OrderNumberRollOverAfter;

rows;
  constructor( private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: OrderService,
    private commonfunction: CommonFunctionService) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetOrderReciptDetails();
  }



  getGetOrderReciptDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      form.id = params["id"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
    });   

    this.service.GetOrderReceiptDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
       if (result!= null) {
       this.rows = result;
          // this.UseLargeFond = result[0].useLargeFond ;
          // this.OrderNotes = result[0].orderNotes ;
          // this.UserAlternativeInventoryName = result[0].userAlternativeInventoryName ;
          // this.GroupLineItems = result[0].groupLineItems ;
          // this.ShowModifierName = result[0].showModifierName ;
          // this.GroupModifiers = result[0].groupModifiers ;
          // this.EmailReceipt = result[0].emailReceipt ;
          //     this.SmsReceipt = result[0].smsReceipt ;
          //     this.ShowCustomerInfo = result[0].showCustomerInfo ;
          //     this.GroupModifiers = result[0].groupModifiers ;


          //     this.receiptId= result[0].Id;
          //     this.PosSubscriptionId= result[0].PosSubscriptionId;
          //     this.AddNoofBlankLineTopOfReceipt= result[0].AddNoofBlankLineTopOfReceipt;
          //     this.OrderNumberType= result[0].OrderNumberType;
          //     this.OrderNumberRollOverAfter = result[0].OrderNumberRollOverAfter;
      } 
    });
 
  }




}
